import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../../components/PageHeader";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import ClaimListWeb from "./ClaimListWeb";
import ClaimListMobile from "./ClaimListMobile";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getCliams} from "../../../../api/claim/ClaimService";

function Claim(props) {

    const [listType, setListType] = useState(true)
    const [checked,setChecked] = useState([]);
    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }
    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const { data, pageInfo, refresh, dataHook, getQr } = useRequestData(getCliams, initDate, 'asset');

    return (
        <div className="common-container">
        <PageHeader header={"요청현황"} indicator={"표준운영절차 > 예방관리 > 요청관리 > 요청현황"}/>
            { listType ?
                <ClaimListWeb data={data} date={initDate} pageInfo={pageInfo}
                              dataHook={dataHook}
                              getQr={getQr}
                              checked={{checked: checked, setChecked: setChecked}} />
                :
                <ClaimListMobile />
            }
        </div>
    );
}

export default Claim;